var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDinersClub(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.958,
    y: 0.208,
    width: 34.583,
    height: 23.583,
    rx: 2.292,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 0.417
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 19.5c3.897.019 7.455-3.208 7.455-7.133 0-4.292-3.558-7.26-7.455-7.258h-3.354c-3.944-.001-7.191 2.967-7.191 7.258 0 3.926 3.247 7.152 7.19 7.133h3.355z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.456 5.704c-3.604.002-6.524 2.95-6.525 6.588 0 3.638 2.921 6.586 6.525 6.587 3.605-.001 6.527-2.95 6.527-6.587 0-3.639-2.922-6.586-6.527-6.588zm-4.136 6.588a4.181 4.181 0 012.656-3.897v7.793a4.179 4.179 0 01-2.656-3.896zm5.617 3.897V8.395a4.179 4.179 0 012.657 3.897 4.18 4.18 0 01-2.657 3.897z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.795 19.5c3.897.019 7.455-3.208 7.455-7.133 0-4.292-3.558-7.26-7.455-7.258h-3.354c-3.944-.001-7.191 2.967-7.191 7.258 0 3.926 3.247 7.152 7.19 7.133h3.355z",
    fill: "#0079BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.456 5.704c-3.604.002-6.524 2.95-6.525 6.588 0 3.638 2.921 6.586 6.525 6.587 3.605-.001 6.527-2.95 6.527-6.587 0-3.639-2.922-6.586-6.527-6.588zm-4.136 6.588a4.181 4.181 0 012.656-3.897v7.793a4.179 4.179 0 01-2.656-3.896zm5.617 3.897V8.395a4.179 4.179 0 012.657 3.897 4.18 4.18 0 01-2.657 3.897z",
    fill: "#fff"
  })));
}
export default SvgDinersClub;